module.exports = __webpack_public_path__ + "img/05_zhTc.be596de7.png";